import { z } from "zod";
import { MediumText, ShortText, idString } from "./common.js";
export const EXPOSURE_RISK_TYPES = [
    "exposure",
    "containment_failure",
    "side_effect",
];
export const EXPOSURE_RISK_CATEGORIES = [
    "safety",
    "customer",
    "quality",
    "regulatory",
    "delivery",
    "operation",
];
export const EXPOSURE_RISK_CRITICALITIES = [
    "unknown",
    "low",
    "medium",
    "high",
    "critical",
];
export const MAX_EXPOSURE_RISK_ASSUMPTIONS = 20;
export const MAX_EXPOSURE_RISKS = 50;
export const ExposureRiskTypeSchema = z.enum(EXPOSURE_RISK_TYPES);
export const ExposureRiskCategorySchema = z.enum(EXPOSURE_RISK_CATEGORIES);
export const ExposureRiskCriticalitySchema = z.enum(EXPOSURE_RISK_CRITICALITIES);
export const ExposureRiskCandidateSchema = z
    .object({
    id: idString,
    title: ShortText,
    type: ExposureRiskTypeSchema,
    category: ExposureRiskCategorySchema,
    description: MediumText,
    affectedScope: MediumText,
    basis: MediumText,
    criticality: ExposureRiskCriticalitySchema,
    assumptions: z.array(MediumText).max(MAX_EXPOSURE_RISK_ASSUMPTIONS),
})
    .strict();
export const ExposureRiskReviewParamsSchema = z
    .object({
    risks: z.array(ExposureRiskCandidateSchema).max(MAX_EXPOSURE_RISKS),
})
    .strict()
    .superRefine((value, ctx) => {
    const seen = new Set();
    value.risks.forEach((risk, index) => {
        if (seen.has(risk.id)) {
            ctx.addIssue({
                code: "custom",
                message: "candidate ids must be unique",
                path: ["risks", index, "id"],
            });
        }
        seen.add(risk.id);
    });
});
export const defaultExposureRiskReviewParams = {
    risks: [],
};
//# sourceMappingURL=exposureRiskReview.js.map